/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
import { EXCHANGE_COUNTRY } from './Onboarding';
import { COIN } from './Order';

export class User {
  _id: string;
  email: string;
  password?: string;
  type: USER_TYPE;
  cuit: string;
  phoneNumber: string;
  name: string;
  searchName: string;
  isCommerce: boolean;
  flags: {
    termsAndConditions: boolean;
    validatedDocuments: boolean;
    mailConfirmed?: boolean;
    firstOnboarding?: boolean;
    appliedRefBenefit?: boolean;
    clubMember?: boolean;
  };
  fundsDocuments: {
    certificacionContable: DOCUMENT_STATUS;
    funds: DOCUMENT_STATUS;
    impuestoCedular: DOCUMENT_STATUS;
  };
  dnis: {
    front: DOCUMENT_STATUS;
    back: DOCUMENT_STATUS;
  };
  bankAccounts: {
    ARS: IBankAccount[];
    USD: IBankAccount[];
    CLP: IBankAccount[];
    COP: IBankAccount[];
    BRL: IBankAccount[];
    GTQ: IBankAccount[];
    CRC: IBankAccount[];
    PUSD: IBankAccount[];
    MXN: IBankAccount[];
    PHP: IBankAccount[];
  };
  cryptoAccounts: ICryptoAccount[];
  balance?: IBalance;
  data?: IPerson;
  cryptoAddress: string;
  terraAddress: string;
  numberId: string;

  // AUX
  accessToken?: string;
  refreshToken?: string;
  activities?: any[];
  orders?: any[];
  deposits?: any[];
  withdrawRequests?: any[];
  transactions?: any[];
  benefitHistory?: any[];
  referralData?: any;
  companyData?: any;
  mediaData?: any[];
  amounts?: number[];
  security?: {
    twoFA: {
      status?: TWOFA_STATUS;
    };
  };
  medals?: IMedal[];
  status?: number;
  portfolio?: any[];
  passportCheck?: any;
  investorProfile?: any;
  isPoliticalPerson?: any;
  under10kUSDDeclarationSigned?: any;
  investorExperience?: any;
  isBanned?: boolean;
  work?: {
    id?: string;
    desc?: string;
  };
  whitelabelAddress?: string;
  whitelabelId?: string;
  whitelabelAlternativeFlow?: boolean;
  exchangeCountry?: string;
  externalFlags?: {
    maybePEP: boolean;
    maybeTerrorist: boolean;
    isPEP: boolean;
    isTerrorist;
  };
  personalDataLastCheck?: Date;
  legalId?: string;
  previewCbu?: string;
}

export interface IComplianceChecks {
  expiredAddress: boolean;
  expiredFunds: boolean;
  expiredPep: boolean;
  expiredPhone: boolean;
  isDead: boolean;
  isUifChange: boolean;
}

export interface ICryptoAccount {
  description: string;
  address: string;
  chain: number;
}

export interface IBankAccount {
  description: string;
  cbu: string;
  actualCbu: string;
  alias?: string;
  id?: number;
  name?: string;
  bankName?: string;
  bankCode?: string;
  accountType?: string;
  network?: string;
}

export interface IEmployee {
  userId: IEmployeeUserId;
  salary: number;
  isArs: boolean;
  coin: string;
}

export interface IEmployeeUserId {
  cuit: string;
  name: string;
}

export interface IBalance {
  fiat: {
    ARS: number;
    USD: number;
  };
  crypto: {
    [coin: string]: any;
  };
  bundle: IBundle;
}
export interface IBundle {
  [fiat: string]: {
    [ticker: string]: any;
  };
}
export enum USER_TYPE {
  TIENDACRYPTO = 0,
  COMPANY = 1,
  WHITELABEL = 2,
}

export interface IPerson {
  firstName?: string;
  lastName?: string;
  street?: string;
  numeration?: string;
  department?: string;
  birthDate?: string;
  sex?: string;
  civilState?: string;
  nationality?: string;
  postalCode?: string;
  province?: string;
  city?: string;
  occupation?: string;
  IVA?: string;
  ganancias?: string;
  isFacta?: boolean;
  isUIF?: boolean;
  isPEP?: boolean;
  isPPT?: boolean;
  pepDoc?: DOCUMENT_STATUS;
  uifDoc?: DOCUMENT_STATUS;
  typeDocument?: 'CC' | 'CE' | 'PPT';
  checkId?: string;
  rep?: string;
  exchangeCountry?: EXCHANGE_COUNTRY;
  truoraCheckId?: string;
  documentation?: {
    ACTA_DESIGNACION?: DOCUMENT_STATUS;
    BALANCE?: DOCUMENT_STATUS;
    CONSTANCIA_DE_CUIT?: DOCUMENT_STATUS;
    ESTATUTO?: DOCUMENT_STATUS;
    IIBB?: DOCUMENT_STATUS;
    ULTIMO_BALANCE_CERTIFICADO?: DOCUMENT_STATUS;
  };
}

export interface IUserInfoField {
  firstName?: string;
  searchName?: string;
  lastName?: string;
  nationality?: string;
  province?: string;
  isUIF?: boolean;
  isPEP?: boolean;
  occupation?: string;
  city?: string;
  civilState?: string;
  street?: string;
  numeration?: string;
  department?: string;
  postalCode?: string;
  sex?: string;
  birthDate?: string;
  IVA?: string;
  ganancias?: string;
  isFacta?: boolean;
  name?: string;
  cuit?: string;
  phoneNumber?: string;
  email?: string;
  issueDate?: string;
  isPPT?: boolean;
  truoraCheckId?: string;
  legalIdType?: number;
}

export interface IUserPepData {
  charge: string;
  authority: string;
  character: string;
}

export enum ORDER_STATUS {
  CREATED,
  CONFIRMED,
  CANCELED,
  WAITING,
  WAITING_SELL_MEP = 12,
  SELL_MEP_EXECUTED = 13,
}

export enum ERROR {
  'CAN_OPERATE' = 0,
  'MAIL_CONFIRMATION' = 1,
  'MISS_MAIN_DATA' = 2,
  'MISS_EXTRA_DATA' = 3,
  'MISS_PEP_DATA' = 4,
  'MISS_DNI_VALIDATION' = 5,
  'BANNED_USER' = 6,
  'MISSING_FUND_ORIGIN' = 7,
  'MISS_JURIDICAL_ACCEPTANCE' = 8,
}

export enum TWOFA_STATUS {
  INACTIVE,
  PENDING_ACTIVATION,
  ACTIVE,
}

export enum DOCUMENT_STATUS {
  NOT_UPLOADED,
  PENDING,
  REJECTED,
  VALIDATED,
}
export enum DOCUMENT_ERRORS {
  REPEATED_DOCUMENTATION = 'REPEATED_DOCUMENTATION',
  DNI_STATUS = 'DNI_STATUS',
  USER_BLOCKED = 'USER_BLOCKED',
  TOO_MANY_PENDING = 'TOO_MANY_PENDING',
}
export interface IMedal {
  description: string;
  mediaData: MEDIA_DATA;
  discount: number;
  name: string;
}

export enum MEDIA_DATA {
  TIENDA_DOLAR = '0',
  FRIEND_AND_FAMILY = '1',
  MERCADO_LIBRE = '2',
}

export interface IBenefitHistory {
  _id: string;
  coin: COIN;
  creationTime: string;
  saved: number;
  source: string;
  type: BENEFIT_TYPE;
}

export interface IUserData {
  pd: PD;
  flag: Flag;
}

export interface Flag {
  checkType: string[];
  _id: string;
  legalId: string;
  provider: string;
  exchangeCountry: string;
  status: string;
  expirationTime: number;
  creationTime: Date;
  updatedAt: Date;
  __v: number;
  proof: string;
  result: boolean;
}

export interface PD {
  isPEP: boolean;
  isTerrorist: boolean;
  isValidCPF: boolean;
  isDead: boolean;
  age: number;
  birthDate: string;
  name: string;
  gender: string;
  surname: string;
  nationality: string;
  activity: string;
  address: Address;
}

export enum ACTIVITY_BR {
  UNEMPLOYED = 'unemployed',
  EMPLOYEE = 'employee',
  ENTREPRENEUR = 'entrepreneur',
  RETIRED = 'retired',
}

export interface Address {
  calle: string;
  codigoPostal: string;
  descripcionProvincia: string;
  direccion: string;
  numero: string;
  piso: string;
  localidad: string;
}

export enum BENEFIT_TYPE {
  COMPANIA = 0,
  REFERRAL = 1,
  REFERRAL_BOOST = 2,
}

export enum ACCOUNT_CURRENCY {
  USD = 'USD',
  ARS = 'ARS',
  CLP = 'CLP',
  COP = 'COP',
  BRL = 'BRL',
  GTQ = 'GTQ',
  PUSD = 'PUSD',
  CRC = 'CRC',
  MXN = 'MXN',
  PHP = 'PHP',
  PEN = 'PEN',
  BOB = 'BOB',
}

export enum ACCOUNT_ERROR {
  COIN_MISMATCH = 'COIN_MISMATCH',
  INVALID_ADDRESS = 'INVALID_ADDRESS',
  INVALID_CBU = 'INVALID_CBU',
}

export interface IProviderData {
  flags: IFlag[];
  identity: Identity;
}

export interface ICuitByDni extends IProviderData {
  cuit: string;
}

export interface IFlag {
  id: string;
  type: string;
  legalId: string;
  provider: string;
  status: string;
  result: boolean;
  proofUrl: string;
  exchangeCountry: string;
  proofRaw: string;
  identityId?: string;
  expireAt: Date;
  creationTime: Date;
  updatedAt: Date;
}

export interface Identity {
  id: string;
  legalId: string;
  provider: string;
  name: string;
  surname: string;
  work: Work;
  birthDate: string;
  nationality: string;
  address: IAddress;
  sex: string;
  personType: string;
  creationTime: Date;
  updatedAt: Date;
}

export interface IAddress {
  street: string;
  postalCode: string;
  province: string;
  complete: string;
  number: string;
  floor: string;
  locality: string;
}

export interface Work {
  id: string;
  desc: string;
}

export const ERROR_MESSAGES = [
  'C1: Generic account error',
  'C2: Bank provided does not match account',
  'C3: Account number does not exist',
  'C4: Account number is inactive or disabled',
  'C5: Account number is invalid',
  'C6: Account currency is invalid',
  'C7: Bank is not supported',
  'C8: Account type is not valid for bank destination',
  'C9: Account type is invalid',
  'D1: Document number does not match account',
  'D2: Document number is invalid',
  'D3: Document number is inactive',
];

export const TRANSLATE_ERROR_MESSAGES: Record<string, string> = {
  'C1: Generic account error': 'Ocurrió un error genérico con la cuenta.',
  'C2: Bank provided does not match account': 'El banco proporcionado no coincide con la cuenta.',
  'C3: Account number does not exist': 'El número de cuenta no existe.',
  'C4: Account number is inactive or disabled': 'La cuenta está inactiva o deshabilitada.',
  'C5: Account number is invalid': 'El número de cuenta es inválido.',
  'C6: Account currency is invalid': 'La moneda de la cuenta no es válida.',
  'C7: Bank is not supported': 'El banco no es compatible.',
  'C8: Account type is not valid for bank destination':
    'El tipo de cuenta no es válido para el banco destino.',
  'C9: Account type is invalid': 'El tipo de cuenta no es válido.',
  'D1: Document number does not match account': 'El número de documento no coincide con la cuenta.',
  'D2: Document number is invalid': 'El número de documento es inválido.',
  'D3: Document number is inactive': 'El número de documento está inactivo.',
};

export const TRANSLATE_ERROR_MESSAGES_BR: Record<string, string> = {
  'C1: Generic account error': 'Ocorreu um erro genérico na conta.',
  'C2: Bank provided does not match account': 'O banco fornecido não corresponde à conta.',
  'C3: Account number does not exist': 'O número da conta não existe.',
  'C4: Account number is inactive or disabled': 'A conta está inativa ou desativada.',
  'C5: Account number is invalid': 'O número da conta é inválido.',
  'C6: Account currency is invalid': 'A moeda da conta é inválida.',
  'C7: Bank is not supported': 'O banco não é compatível.',
  'C8: Account type is not valid for bank destination':
    'O tipo de conta não é válido para o banco de destino.',
  'C9: Account type is invalid': 'O tipo de conta é inválido.',
  'D1: Document number does not match account': 'O número do documento não corresponde à conta.',
  'D2: Document number is invalid': 'O número do documento é inválido.',
  'D3: Document number is inactive': 'O número do documento está inativo.',
};

export const TRANSLATE_ERROR_MESSAGES_PHL: Record<string, string> = {
  'C1: Generic account error': 'May naganap na pangkalahatang error sa account.',
  'C2: Bank provided does not match account':
    'Ang ibinigay na bangko ay hindi tumutugma sa account.',
  'C3: Account number does not exist': 'Hindi umiiral ang numero ng account.',
  'C4: Account number is inactive or disabled': 'Ang account ay hindi aktibo o naka-disable.',
  'C5: Account number is invalid': 'Ang numero ng account ay hindi balido (invalid).',
  'C6: Account currency is invalid': 'Hindi balido ang currency ng account.',
  'C7: Bank is not supported': 'Hindi compatible ang bangko.',
  'C8: Account type is not valid for bank destination':
    'Hindi balido ang uri ng account para sa destinasyon ng bangko.',
  'C9: Account type is invalid': 'Hindi balido ang uri ng account.',
  'D1: Document number does not match account':
    'Ang numero ng dokumento ay hindi tumutugma sa account.',
  'D2: Document number is invalid': 'Ang numero ng dokumento ay hindi balido.',
  'D3: Document number is inactive': 'Ang numero ng dokumento ay hindi aktibo.',
};

export enum AUTH_ERROR {
  NOT_HUMAN = 'NOT_HUMAN',
  BAD_REQUEST = 'BAD_REQUEST',
  USER_NF = 'USER_NF',
  MAX_LOGIN_ATTEMPS = 'MAX_LOGIN_ATTEMPS',
  USER_NOT_COMMERCE = 'USER_NOT_COMMERCE',
}

export enum DOCUMENT_TYPE {
  FRONT = 'DNI_FRONT',
  BACK = 'DNI_BACK',
  BALANCE = 'BALANCE',
  ESTATUTO = 'ESTATUTO',
  FUNDS = 'FUNDS',
  IIBB = 'IIBB',
  ACTA_DESIGNACION = 'ACTA_DESIGNACION',
  ULTIMO_BALANCE_CERTIFICADO = 'ULTIMO_BALANCE_CERTIFICADO',
  CONSTANCIA_DE_CUIT = 'CONSTANCIA_DE_CUIT',
  PEP_DDJJ = 'PEP_DDJJ',
  EXTRA = 'EXTRA',
  CERTIFICACION_CONTABLE = 'CERTIFICACION_CONTABLE',
  IMPUESTO_CEDULAR = 'IMPUESTO_CEDULAR',
  DDJJ_BENEFICIARIO_FINAL = 'DDJJ_BENEFICIARIO_FINAL',
  SUJETO_OBLIGADO_DDJJ = 'SUJETO_OBLIGADO_DDJJ',
}

export enum DOCUMENT_TYPE_NAME {
  FRONT = 'Dni frente',
  BACK = 'Dni dorso',
  BALANCE = 'Último Balance',
  ESTATUTO = 'Estatuto social',
  FUNDS = 'Origen de fondo',
  IIBB = 'Constancia IIBB',
  ACTA_DESIGNACION = 'Acta de designacion de autoridades',
  ULTIMO_BALANCE_CERTIFICADO = 'Certificado de último balance',
  CONSTANCIA_DE_CUIT = 'Constancia de Cuit',
  PEP_DDJJ = 'Declaración jurada sobre la condición de personas expuestas políticamente',
  SUJETO_OBLIGADO_DDJJ = 'Declaración jurada de sujeto obligado',
  EXTRA = 'Extra',
  CERTIFICACION_CONTABLE = 'Certificación contable',
  IMPUESTO_CEDULAR = 'Impuesto cedular',
}

export enum BANK_NAME {
  'BANCO DE GALICIA Y BUENOS AIRES S.A.U.' = 7,
  'BANCO DE LA NACION ARGENTINA' = 11,
  'BANCO DE LA PROVINCIA DE BUENOS AIRES' = 14,
  'INDUSTRIAL AND COMMERCIAL BANK OF CHINA' = 15,
  'CITIBANK N.A.' = 16,
  'BANCO BBVA ARGENTINA S.A.' = 17,
  'BANCO DE LA PROVINCIA DE CORDOBA S.A.' = 20,
  'BANCO SUPERVIELLE S.A.' = 27,
  'BANCO DE LA CIUDAD DE BUENOS AIRES' = 29,
  'BANCO PATAGONIA S.A.' = 34,
  'BANCO HIPOTECARIO S.A.' = 44,
  'BANCO DE SAN JUAN S.A.' = 45,
  'BANCO MUNICIPAL DE ROSARIO' = 65,
  'BANCO SANTANDER RIO S.A.' = 72,
  'BANCO DEL CHUBUT S.A.' = 83,
  'BANCO DE SANTA CRUZ S.A.' = 86,
  'BANCO DE LA PAMPA SOCIEDAD DE ECONOMÍA M' = 93,
  'BANCO DE CORRIENTES S.A.' = 94,
  'BANCO PROVINCIA DEL NEUQUÉN SOCIEDAD ANÓ' = 97,
  'BRUBANK S.A.U.' = 143,
  'BANCO INTERFINANZAS S.A.' = 147,
  'HSBC BANK ARGENTINA S.A.' = 150,
  'OPEN BANK ARGENTINA S.A.' = 158,
  'JPMORGAN CHASE BANK, NATIONAL ASSOCIATIO' = 165,
  'BANCO CREDICOOP COOPERATIVO LIMITADO' = 191,
  'BANCO DE VALORES S.A.' = 198,
  'BANCO ROELA S.A.' = 247,
  'BANCO MARIVA S.A.' = 254,
  'BANCO ITAU ARGENTINA S.A.' = 259,
  'BNP PARIBAS' = 266,
  'BANCO PROVINCIA DE TIERRA DEL FUEGO' = 268,
  'BANCO DE LA REPUBLICA ORIENTAL DEL URUGU' = 269,
  'BANCO SAENZ S.A.' = 277,
  'BANCO MERIDIAN S.A.' = 281,
  'BANCO MACRO S.A.' = 285,
  'BANCO COMAFI SOCIEDAD ANONIMA' = 299,
  'BANCO DE INVERSION Y COMERCIO EXTERIOR S' = 300,
  'BANCO PIANO S.A.' = 301,
  'BANCO JULIO SOCIEDAD ANONIMA' = 305,
  'BANCO RIOJA SOCIEDAD ANONIMA UNIPERSONAL' = 309,
  'BANCO DEL SOL S.A.' = 310,
  'NUEVO BANCO DEL CHACO S. A.' = 311,
  'BANCO VOII S.A.' = 312,
  'BANCO DE FORMOSA S.A.' = 315,
  'BANCO CMF S.A.' = 319,
  'BANCO DE SANTIAGO DEL ESTERO S.A.' = 321,
  'BANCO INDUSTRIAL S.A.' = 322,
  'NUEVO BANCO DE SANTA FE SOCIEDAD ANONIMA' = 330,
  'BANCO CETELEM ARGENTINA S.A.' = 331,
  'BANCO DE SERVICIOS FINANCIEROS S.A.' = 332,
  'BANCO BRADESCO ARGENTINA S.A.U.' = 336,
  'BANCO DE SERVICIOS Y TRANSACCIONES S.A.' = 338,
  'RCI BANQUE S.A.' = 339,
  'BACS BANCO DE CREDITO Y SECURITIZACION S' = 340,
  'BANCO MASVENTAS S.A.' = 341,
  'WILOBANK S.A.' = 384,
  'NUEVO BANCO DE ENTRE RÍOS S.A.' = 386,
  'BANCO COLUMBIA S.A.' = 389,
  'BANCO BICA S.A.' = 426,
  'BANCO COINAG S.A.' = 431,
  'BANCO DE COMERCIO S.A.' = 432,
  'BANCO SUCREDITO REGIONAL S.A.U.' = 435,
  'BANCO DINO S.A.' = 448,
  'BANK OF CHINA LIMITED SUCURSAL BUENOS AI' = 515,
  'FORD CREDIT COMPAÑIA FINANCIERA S.A.' = 44059,
  'COMPAÑIA FINANCIERA ARGENTINA S.A.' = 44077,
  'VOLKSWAGEN FINANCIAL SERVICES COMPAÑIA F' = 44088,
  'IUDU COMPAÑÍA FINANCIERA S.A.' = 44090,
  'FCA COMPAÑIA FINANCIERA S.A.' = 44092,
  'GPAT COMPAÑIA FINANCIERA S.A.U.' = 44093,
  'MERCEDES-BENZ COMPAÑÍA FINANCIERA ARGENT' = 44094,
  'ROMBO COMPAÑÍA FINANCIERA S.A.' = 44095,
  'JOHN DEERE CREDIT COMPAÑÍA FINANCIERA S.' = 44096,
  'PSA FINANCE ARGENTINA COMPAÑÍA FINANCIER' = 44098,
  'TOYOTA COMPAÑÍA FINANCIERA DE ARGENTINA' = 44099,
  'NARANJA DIGITAL COMPAÑÍA FINANCIERA S.A.' = 45030,
  'MONTEMAR COMPAÑIA FINANCIERA S.A.' = 45056,
  'TRANSATLANTICA COMPAÑIA FINANCIERA S.A.' = 45072,
  'CREDITO REGIONAL COMPAÑIA FINANCIERA S.A' = 65203,
}

export enum PAYMENT_SERVICE_NAME {
  'Mercado Pago' = 31,
  'Ank' = 475,
  'Bitso' = 253,
  'BKR' = 390,
  'CuentaDigital.com' = 437,
  'GOAT S.A' = 1140,
  'INVOITION' = 116,
  'Naranja X' = 147,
  'Nubi' = 291,
  'Paymovil' = 277,
  'Pluspagos (Billetera Santa Fe)' = 62,
  'Prex' = 130,
  'Propago' = 741,
  'Resimple' = 345,
  'Sysworld Digital S.A.' = 666,
  'Satoshitango' = 222,
  'TAP Billetera Virtual' = 406,
  'Ualá' = 79,
  'PagosOnline' = 1270,
  'YPF' = 1225,
  'BAMBA' = 1201,
}

export enum DEVICE_TYPE {
  iOS,
  Android,
  Web,
}

export enum COL_DOC_TYPE {
  CC, // Carnet de ciudadanía: ciudadanos colombianos
  CE, // Carnet de extranjería: extranjeros residentes
  PPT, // Programa de protección temporal (Venezolanos)
}

export const documentType = {
  CC: COL_DOC_TYPE.CC,
  CE: COL_DOC_TYPE.CE,
  PPT: COL_DOC_TYPE.PPT,
};

export enum USER_DOC_TYPE {
  NATIONAL_ID,
  FOREIGN_ID,
}
